import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

const Paych = () => {
  return (
    <React.Fragment>
      <SEO title="会议注册费| ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="支付会议注册费"
        content="会议注册"
        contentTwo="支付会议注册费"
        linkage="/registration"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div classNameName="entry-header">
          <h3>会议注册费</h3>
          <br />
          <span className="pay-guide">
            (If you need English Payment Guidance, please click{" "}
            <a className="simple-link" href="pay">
              here
            </a>
            )
          </span>
        </div>
        <div classNameName="entry-content">
          <div className="fee">
            <div align="center">
              <br />
              <h5>注册费明细</h5>
            </div>
            <table className="fee">
              <tr>
                <td width="183">
                  <p align="center">项目 </p>
                </td>
                <td width="152">
                  <p align="center">费用（人民币元） </p>
                </td>
                <td width="691">
                  <p align="center">包括内容 </p>
                </td>
              </tr>
              <tr>
                <td width="183">
                  <p align="center">正常注册 </p>
                </td>
                <td width="152">
                  <p align="center">5960</p>
                </td>
                <td width="691">
                  <p>
                    这适用于有论文录用的参会者。
                    <br />
                    包括：Springer-LNCS论文集上发表1篇论文，电子版论文集，会议程序册，会议包，胸牌，出席所有的大会报告会、平行口头报告会和板报研讨会，会议期间的午餐券与晚宴券。{" "}
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <div align="center">简化注册 </div>
                </td>
                <td>
                  <div align="center">5000</div>
                </td>
                <td>
                  <p>
                    这适用于以下两种情况：
                    <br />
                    1、同一作者的第二篇论文的注册。
                    <br />
                    2、没有论文发表的参会者或参会陪伴者。
                    <br />
                  </p>{" "}
                </td>
              </tr>
              {/* <tr>
                <td>
                  <div align="center">简化线上注册 </div>
                </td>
                <td>
                  <div align="center">2350</div>
                </td>
                <td>
                  <p>
                    这适用于以下两种情况：
                    <br />
                    1、一位作者选择正常注册线下参会，其它作者选择线上参会，则其它作者需要选择简化线上注册（多位作者线上参会只需要注册一位）。
                    <br />
                    2、一位作者选择简化注册线上参会，其它作者选择线上参会，则其它作者需要选择简化线上注册（多位作者线上参会只需要注册一位）。
                    <br />
                  </p>{" "}
                </td>
              </tr> */}

              <tr>
                <td colSpan="3">&nbsp;</td>
              </tr>
              <tr>
                <td width="183">
                  <p align="center">超页 </p>
                </td>
                <td width="152">
                  <p align="center">900</p>
                </td>
                <td width="691">
                  <p align="left">如果论文超过12页，每1个超页。 </p>
                </td>
              </tr>
              <tr>
                <td width="183">
                  <p align="center">宴会券 </p>
                </td>
                <td width="152">
                  <p align="center">720</p>
                </td>
                <td width="691">
                  <p align="left">每1张宴会券。 </p>
                </td>
              </tr>
              <tr>
                <td width="183">
                  <p align="center">午餐券 </p>
                </td>
                <td width="152">
                  <p align="center">360</p>
                </td>
                <td width="691">
                  <p align="left">
                    每1张午餐券。{" "}
                    <a href="http://item.taobao.com/item.htm?id=22998448148"></a>
                  </p>
                </td>
              </tr>
            </table>
            <br />
            <span>
              <b>注意：</b>
            </span>
            {/* 由于会议在中国举行，ICSI&apos;2025的注册费以人民币结算，注册中的每一项价值与以往ICSI系列会议相同。 */}
            <div align="justify">
              <ul>
                <li>
              关于发票：本次国际会议默认都提供英文收据（Receipt）。如果你需要换开中文正规发票，请您在完成注册缴费后，在问卷中填写发票信息。经审核无误后会尽快为您开具相应的正规电子发票。
               </li>
               <li>
                关于汇率：本次国际会议以美元结算，人民币按照2026年5月5日的实时汇率（6.83）进行计算。
               </li>
              </ul>
            </div>
            <div align="justify">
              {" "}
              <span className="entry-header">
              </span>{" "}
            </div>
          </div>
          <p>&nbsp;</p>
          <hr />
          <p>&nbsp;</p>
          <div className="post-entry">
            {" "}
            <h3>收款方式</h3>
            <br />
            <h5>1.收款二维码：</h5>
            <br />
            <p align="center">
              <img src="./images/reg/yunpay.jpg" alt="2dQr" width="450" />
            </p>
            <p align="center">&nbsp;</p>
            <p className="STYLE39">
              请将会议注册费直接转账到上面云收款二维码账户中，然后将
              <span className="STYLE23">交易成功网页</span>
              保存为图片文件，并在随后填写
              <a href="http://www.ic-si.org/limesurvey/index.php?sid=44671">
                Online Registration Form{" "}
              </a>
              时上传。需在备注栏填写&quot;会议名称和论文编号&quot;，即&quot;ICSI2026/xxx&quot;(其中&quot;xxx&quot;为所注册论文的编号)。
            </p>
            <p>&nbsp;</p>
            <hr />
            <p>&nbsp;</p>
            <p>
              <h5> 2. 普通银行转账：</h5>
            </p>
            <span className="STYLE27">账号信息</span>
            <ul>
              <li>账户名称：北京兴汇科技有限公司</li>
              <li>开户行名称：平安银行股份有限公司北京中关村支行</li>
              <li>开户银行帐号：11014748324007</li>
            </ul>
            <p>
              <span>
                <strong>特别注明：</strong>
              </span>
              <li>
                通过银行转账付款的
                需在备注栏填写&quot;会议名称和论文编号&quot;，即&quot;ICSI2026/xxx&quot;(其中&quot;xxx&quot;为所注册论文的编号，若是简化注册则写上交款人姓名)，银行凭证扫描成JPG图片文件并通过在线注册表上载。
              </li>
              <li>
                注册中有什么疑问，请及时与会务组联系。
                <br />
              </li>
            </p>
          </div>
          <p align="center">&nbsp;</p>
          <div className="btn-nav-pay">
            {/* <a
              className="btn btn-primary btn-hover-secondary mt-s"
              href="https://wj.qq.com/s2/9997438/2b92/"
            >
              Fill Online Registration Form
            </a> */}
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/form"}
            >
              Fill Online Registration Form
              {/* Back to Registration page */}
            </Link>
            <br />
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/registration"}
            >
              Back to Registration page
            </Link>

            {/* <p>
              <a href="/Registration">Back to Registration page </a>
            </p>
            <p>
              <a href="https://iasei.org/survey/index.php/677672?lang=en">
                Fill Online Registration Form{" "}
              </a>
            </p> */}
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classNameOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Paych;
